import axios from "axios";
/* eslint-disable react-hooks/rules-of-hooks */
import { ITareaTomarLiberarPost } from "../../interfaces/backendApi/tareaTomarLiberar";
import {
  ICrearCaso,
  IInsertarGuardia,
} from "../../interfaces/backendApi/ticketInsertar";
import { ITareaResolverPost } from "../../interfaces/backendApi/tareaResover";
import { ITicketModificarPost } from "../../interfaces/backendApi/ticketModificar";
import { SwitchIdContratoTarea } from "./SwitchIdContratoTarea";
import { credenciales } from "./credenciales";
import { ITareasRm } from "../../interfaces/backendApi/tareasRm";
import { IAsignarTarea } from "../../interfaces/backendApi/asignarTarea";
import { IAsignarTareaManual } from "../../interfaces/backendApi/asignarTareaManual";
import { iAcreditarHs } from "../../interfaces/backendApi/acreditarHs";
import { obtenerTimeZoneNum } from "../helper/helperApi";
import { IAsignarTareaAutomaticamente } from "../../interfaces/backendApi/asignarTareaAutomaticamente";
import { IModificarCasoPrioridad } from "../../interfaces/backendApi/modificarCasoPrioridad";
import { IEntradasFiltradas } from "../../interfaces/backendApi/entradasFiltradas";
import { IIngresarInsumoTiempo } from "../../interfaces/backendApi/ingresarInsumoTiempo";
import { IPonderacionesUsuariosGet } from "../../interfaces/backendApi/ponderacionesUsuarios";
import { IInsertarEvento } from "../../interfaces/backendApi/eventoInsertar";
import { IModificarEvento } from "../../interfaces/backendApi/eventoModificar";
import { IEliminarEvento } from "../../interfaces/backendApi/eventoEliminar";
import { IObtenerEventosRequest } from "../../interfaces/backendApi/eventoObtener";
import { IObtenerEventoRequest } from "../../interfaces/backendApi/eventoObtenerSingular";
import { IInsertarTipoNotificacion } from "../../interfaces/backendApi/tipoNotificacionInsertar";
import { IModificarTipoNotificacion } from "../../interfaces/backendApi/tipoNotificacionModificar";
import { IEliminarTipoNotificacion } from "../../interfaces/backendApi/tipoNotificacionEliminar";
import { IObtenerTipoNotificacionRequest } from "../../interfaces/backendApi/tipoNotificacionObtener";
import { IModificarVariableNotificacion } from "../../interfaces/backendApi/variableNotificacionModificar";
import { IObtenerVariableNotificacionRequest } from "../../interfaces/backendApi/variableNotificacionObtenerSingular";
import { IActualizarNotificacion } from "../../interfaces/backendApi/actualizarNotificacion";
import {
  IActualizarConfiguracionRequest,
  IObtenerConfiguracionesRequest,
} from "../../interfaces/backendApi/configuracionNotificacion";
import { IPerfilObtenerRequest } from "../../interfaces/backendApi/perfilObtener";
import { IPayloadBuscaquedaCasosTareas } from "../../interfaces/backendApi/busquedaCasosTareas";

export const getCurrentDomain = (): string => {
  return window.location.hostname;
};

export const isLocalhost = getCurrentDomain() === "localhost";

/**
 * Retorna la URL de la API o una URL de fallo rápido si el entorno
 * es localhost y el horario está fuera de servicio.
 * @param apiEndpoint El endpoint de la API, por ejemplo, '/adjuntos/obtenerArchivo'.
 * @returns La URL de la API a la que se debe llamar.
 */
export const getApiUrl = (apiEndpoint: string): string => {
  const isLocalhost = getCurrentDomain() === "localhost";

  if (isLocalhost) {
    console.warn(
      "API no disponible, forzando error de conexión para usar mocks.",
    );
    // Devuelve una URL que fallará de inmediato
    return "http://localhost:1" + apiEndpoint;
  }

  // Si no se cumplen las condiciones, usa la URL de la API real
  return process.env.REACT_APP_URL_API + apiEndpoint;
};
export const BackendIniciarSession = async (
  usuario: string,
  password: string,
) => {
  let Utc = obtenerTimeZoneNum();
  let url = getApiUrl("" + process.env.REACT_APP_INICIAR_SESION);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  return await axios.post(url, {
    usuario: {
      usuario: usuario,
      Password: password,
    },
    Utc: Utc,
  });
};

export const BackendModificarUsuario = async (
  Password: string,
  NuevaPassword: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();

  let url = getApiUrl(
    "" +
    (process.env.REACT_APP_MODIFICAR_USUARIO ||
      "/api/Usuarios/ModificarUsuario"),
  );

  let data = JSON.stringify({
    Password: Password,
    NuevaPassword: NuevaPassword,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendAsignarTareaAutomaticamente = async (
  payload: IAsignarTareaAutomaticamente,
) => {
  const { IdSesion, tokenBacked } = await credenciales();

  let url = getApiUrl("" + process.env.REACT_APP_ASIGNAR_TAREA_AUTOMATICA);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdTarea: payload.IdTarea,
    Caso: payload.Caso,
    IdCategoria: payload.IdCategoria,
    Principal: payload.Principal,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerEstadoTareas = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_ESTADO_TAREAS);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerCategorias = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_CATEGORIAS);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerTiposMime = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_TIPOS_MIME);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendUsuariosGuardia = async (
  IdCategoria: number,
  Nivel: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_USUARIOS_GUARDIA);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  let data = JSON.stringify({
    categoria: {
      IdCategoria: IdCategoria,
    },
    Nivel: Nivel,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendUsuarios = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENERUSUARIOS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  let data = JSON.stringify({
    categoria: {
      IdCategoria: 0,
    },
    Nivel: "",
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendUsuariosTorre = async (
  IdTareaCatalogo: number,
  FechaHora: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENERUSUARIOS_TORRE);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  let data = JSON.stringify({
    IdTareaCatalogo: IdTareaCatalogo,
    FechaHora: FechaHora,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendPausaExcedida = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_PAUSAEXCEDIDA);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendRespuestaPausaExcedida = async (
  IdTarea: number,
  Caso: number,
  Estado: string,
  IdTipo: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_RESPUESTAPAUSAEXCEDIDA);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdTarea: IdTarea,
    Caso: Caso,
    Estado: Estado, //"Pausada", // "Tomada" Liberada
    IdTipo: IdTipo,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendInsertarEvento = async (datos: IInsertarEvento) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_INSERTAR_EVENTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify(datos);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendModificarEvento = async (datos: IModificarEvento) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_MODIFICAR_EVENTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify(datos);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendEliminarEvento = async (datos: IEliminarEvento) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ELIMINAR_EVENTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Codigo: datos.Codigo,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerEventos = async (datos: IObtenerEventosRequest) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_EVENTOS);
  axios.defaults.headers.post["Content-Type"] = "application/json;charset=ut8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    VectorDestinatarios: datos.VectorDestinatarios || [],
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerEvento = async (datos: IObtenerEventoRequest) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_EVENTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Codigo: datos.Codigo,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendInsertarTipoNotificacion = async (
  datos: IInsertarTipoNotificacion,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_INSERTAR_TIPO_NOTIFICACION);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Codigo: datos.Codigo,
    Tipo: datos.Tipo,
    Descripcion: datos.Descripcion,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendModificarTipoNotificacion = async (
  datos: IModificarTipoNotificacion,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_MODIFICAR_TIPO_NOTIFICACION);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Codigo: datos.Codigo,
    Tipo: datos.Tipo,
    Descripcion: datos.Descripcion,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendEliminarTipoNotificacion = async (
  datos: IEliminarTipoNotificacion,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ELIMINAR_TIPO_NOTIFICACION);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Codigo: datos.Codigo,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerTipoNotificacion = async (
  datos: IObtenerTipoNotificacionRequest,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_TIPO_NOTIFICACION);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Codigo: datos.Codigo,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerTiposNotificaciones = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_TIPOS_NOTIFICACIONES);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
  };

  return await axios(config);
};

export const BackendModificarVariableNotificacion = async (
  datos: IModificarVariableNotificacion,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_MODIFICAR_VARIABLE_NOTIFICACION,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Codigo: datos.Codigo,
    Nombre: datos.Nombre,
    Descripcion: datos.Descripcion,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerVariablesNotificaciones = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_OBTENER_VARIABLES_NOTIFICACIONES,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
  };

  return await axios(config);
};

export const BackendObtenerVariableNotificacion = async (
  datos: IObtenerVariableNotificacionRequest,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_VARIABLE_NOTIFICACION);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Nombre: datos.Nombre,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerPonderaciones = async (
  filtros: IPonderacionesUsuariosGet,
) => {
  const { IdSesion, tokenBacked } = await credenciales();

  let url = getApiUrl("/api/PonderacionesUsuarios/ObtenerPonderaciones");
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify(filtros);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerPerfiles = async (datos: IPerfilObtenerRequest) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("/api/Perfiles/ObtenerPerfiles");
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify(datos);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendAdjuntarArchivo = async (
  Caso: number,
  Titulo: string,
  Descripcion: string,
  Nombre: string,
  Tipo: string,
  Base64: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ADJUNTAR_ARCHIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Caso: Caso,
    Titulo: Titulo,
    Descripcion: Descripcion,
    Nombre: Nombre,
    Tipo: Tipo,
    Base64: Base64,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendAdjuntosIngresarArchivo = async (
  Caso: number,
  Titulo: string,
  Descripcion: string,
  Nombre: string,
  Tipo: string,
  Base64: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ADJUNTOS_INGRESAR_ARCHIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Caso: Caso,
    Titulo: Titulo,
    Descripcion: Descripcion,
    Nombre: Nombre,
    Tipo: Tipo,
    Base64: Base64,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendRecuperarArchivoAdjunto = async (Caso: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_RECUPERAR_ARCHIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ Caso: Caso });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerArchivo = async (
  Caso: number,
  IdArchivo: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ADJUNTOS_OBTENER_ARCHIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ Caso: Caso, IdArchivo: IdArchivo });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendObtenerAdjuntosCaso = async (Caso: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_ADJUNTOS_OBTENER_ADJUNTOS_CASO,
  );

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ Caso: Caso });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendInsertarGuardia = async (datos: IInsertarGuardia) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_INSERTAR_GUARDIA);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Usuario: datos.Usuario, //"eduardo.weglin@synchro-technologies.com",
    FechaHoraDesde: datos.FechaHoraDesde, // "2024-07-10 19:00:00",
    FechaHoraHasta: datos.FechaHoraHasta,
    Principal: datos.Principal, // "2024-07-10 22:00:00",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendModificarCasoPrioridad = async (
  datos: IModificarCasoPrioridad,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CASO_MODIFICAR_PRIORIDAD);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Caso: datos.Caso,
    Prioridad: Number(datos.Prioridad),
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendModificarGuardia = async (
  IdGuardia: number,
  Estado: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_MODIFICAR_GUARDIA);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdGuardia: IdGuardia,
    Estado: Estado, //"Realizada"
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerGuardia = async (Estado: string) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_GUARDIA);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Estado: Estado, //"'Pendiente', 'Cancelada', o 'Realizada'",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerTiposPausa = async (DisplayName: string) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_OBTENER_TIPOS_PAUSA);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    DisplayName: DisplayName
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendPausarTarea = async (
  id: string,
  caseId: string,
  state: string, //"Pausada", //"Tomada"
  type: string, // Entero entre comillas. Id del Tipo de Pausa.
  executedBy: string, // Entero entre comillas. Id del Modo, para ejecutar el check in out en la base de dato
  description: string,
  displayName: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_PAUSAR);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  const payload = {
    id,
    caseId,
    state,
    type,
    executedBy,
    description,
    ...(displayName !== "" && { displayName }),
  };

  const data = JSON.stringify(payload);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendReiniciarTarea = async (
  id: string,
  caseId: string,
  state: string, //"Pausada", //"Tomada"
  type: string, // Entero entre comillas. Id del Tipo de Pausa.
  executedBy: string, // Entero entre comillas. Id del Modo, para ejecutar el check in out en la base de dato
  description: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_REINICIAR);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    id: id,
    caseId: caseId,
    state: state, //"Pausada", //"Tomada"
    type: type, // Entero entre comillas. Id del Tipo de Pausa.
    executedBy: executedBy, // Entero entre comillas. Id del Modo, para ejecutar el check in out en la base de datos
    description: description,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendActualizarNotificaciones = async (
  payload: IActualizarNotificacion,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ACTUALIZAR_NOTIFICACIONES);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify(payload);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendObtenerNotificaciones = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_NOTIFICACIONES);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendActualizarDisponibilidad = async (
  disponible: boolean,
  disponibleGuardia: boolean,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ACTUALIZAR_DISPONIBILIDAD);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Disponible: disponible,
    DisponibleGuardia: disponibleGuardia,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasCompletadasCasoPorUsuario = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_LISTATAREASCOMPLETADASCASOPORUSUARIO,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasActivasCasoPorUsuario = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();

  let url = getApiUrl(
    "" + process.env.REACT_APP_LISTATAREASACTIVASCASOPORUSUARIO,
  );

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ Caso: caseId });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareaTiempoEstimRef = async (
  recursoContexto: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_RECURSOCONTEXTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ description: recursoContexto });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaTareaTiempoRef = async (recursoContexto: string) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_RECURSOCONTEXTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ description: recursoContexto });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaTareaOperadorRef = async (recursoContexto: string) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_RECURSOCONTEXTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ description: recursoContexto });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaTareasRecurso = async (
  IdTarea: string,
  Estado: string,
  Cantidad: number, //2, // 0 para traer todos
  NumPagina: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASRECURSO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdTarea: IdTarea,
    Estado: Estado,
    Cantidad: Cantidad,
    NumPagina: NumPagina,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasTomadasRecurso = async (
  IdTarea: string,
  Estado: string | null,
  Cantidad: number,
  NumPagina: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASRECURSO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  let data = JSON.stringify({
    IdTarea: IdTarea,
    Estado: Estado,
    Cantidad: Cantidad,
    NumPagina: NumPagina,
  });
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaTareaIdRecurso = async (
  IdTarea: string,
  Caso: string,
  Estado: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREAIDRECURSO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdTarea: IdTarea,
    Caso: Caso,
    //Estado: Estado, // 'A Tomar' // 'Tomadas'
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaTareaRm = async (
  payload: ITareasRm,
  filtrar: boolean,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREA_RM);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  const { Cantidad, NumPagina, ...payloadSinPaginacion } = payload;

  const data = JSON.stringify(
    Cantidad === 0 && NumPagina === 0
      ? payloadSinPaginacion
      : payload,
  );
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaEstadoUsuarios = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ESTADO_USUARIOS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendAsignarTarea = async (payload: IAsignarTarea) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ASIGNAR_TAREA);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdTarea: payload.IdTarea, // 620180,
    Caso: payload.Caso, // 118038,
    Prioridad: payload.Prioridad, // "1", // Valores aceptados: 0/1/2
    FechaVenc: payload.FechaVenc, //  "2024-08-09 23:00:00", // Fecha y hora de vencimiento de la tarea, en formato aaaa-mm-dd hh:mm:ss
    Usuario: payload.Usuario, //  "", // Comillas vacías para asignación automática. Cadena de usuario para asignación manual
    FechaHoraInicio: payload.FechaHoraInicio, // "2024-06-14 15:25:00", // Fecha y hora de inicio, en formato aaaa-mm-dd hh:mm:ss
    Duracion: payload.Duracion, // 34, // Entero, minutos de duración de la tarea
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendAcreditarHs = async (payload: iAcreditarHs) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ACREDITAR_HS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Acreditado: payload.Acreditado,
    Detalle: payload.Detalle,
    Caso: payload.Caso,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendObtenerCustomFieldsContrato = async (
  IdContrato: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_CUSTOMFIELDS_CONTRATO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdContrato: IdContrato,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendAsignarTareaManual = async (
  payload: IAsignarTareaManual,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ASIGNAR_TAREA_MANUAL);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdTarea: payload.IdTarea, //5,
    Caso: payload.Caso, //175035,
    Usuario: payload.Usuario, //"hernan.mucignat@synchro-technologies.com",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaTareasCompletadasUsuario = async (
  Cantidad: number,
  NumPagina: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREACOMPLETADASUSUARIO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ Cantidad: Cantidad, NumPagina: NumPagina });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendComentariosCasoArchivado = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_COMENTARIOSCASOARCHIVADO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerEstadoUsuario = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_ESTADO_USUARIO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerUsuario = async (usuario: string) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_USUARIO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    usuario: usuario,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendIngresarInsumoTiempo = async (
  IngresarInsumoTiempo: IIngresarInsumoTiempo,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_INGRESAR_INSUMO_TIEMPO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Usuario: IngresarInsumoTiempo.Usuario,
    Tarea: IngresarInsumoTiempo.Tarea,
    Caso: IngresarInsumoTiempo.Caso,
    HsReales: IngresarInsumoTiempo.HsReales,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendComentariosCasoActivo = async (caseId: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_COMENTARIOSCASOACTIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendMovimientosCasoActivo = async (Caso: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_MOVIMIENTOS_CASO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Caso: Caso,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendObtenerEntradasFiltradas = async (
  EntradasFiltradas: IEntradasFiltradas,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_ENTRADAS_FILTRADAS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Usuario: EntradasFiltradas.Usuario,
    FechaDesde: EntradasFiltradas.FechaDesde,
    FechaHasta: EntradasFiltradas.FechaHasta,
    Caso: EntradasFiltradas.Caso,
    Contrato: EntradasFiltradas.Contrato,
    Cliente: EntradasFiltradas.Cliente,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendTareasCasoArchivado = async (caseId: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREASCASOARCHIVADO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendCasoArchivadoPorIdContext = async (caseId: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CASOARCHIVADOPORIDCONTEXTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendPausaDiaria = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_PAUSAS_DIARIAS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendCasoActivoPorId211 = async (caseId: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CASOACTIVOPORID);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };
  return await axios(config);
};

export const BackendCasoPorId = async (caseId: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CASOPORID);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Caso: caseId,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };
  return await axios(config);
};
export const BackendCasoArchivadoPorId = async (caseId: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CASOPORID);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Caso: caseId,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };
  return await axios(config);
};

export const BackendCasosActivosPorContratoId = async (
  IdCliente: number,
  IdContrato: number,
  TipoTicket: number, // 0 para Activos, 1 para inactivos
  IdCategoria: number, // Opcional, más de 0 para filtrar por categoría
  Cantidad: number, //2, // 0 para traer todos
  NumPagina: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTACASOSPORCONTRATO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    contrato: {
      IdContrato: IdContrato, // 0 para traer de todos los contratos
      cliente: {
        IdCliente: IdCliente, // 0 para traer de todos los cliente
      },
    },
    TipoTicket: TipoTicket, // 0 para Activos, 1 para inactivos
    IdCategoria: IdCategoria, // Opcional, más de 0 para filtrar por categoría
    Cantidad: Cantidad, // 0 para traer todos
    NumPagina: NumPagina, // 0 para traer todos, comienza a contar a par
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendCasoActivoPorIdContext = async (caseId: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CASOACTIVOPORIDCONTEXT);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

//FALTA
export const BackendCasosPorCliente = async (
  IdCliente: number,
  user_id: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CASOSPORCLIENTE);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    cliente: {
      user_id: user_id,
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendTareasCasoActivo = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREASCASOACTIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaCasosActivo = async (
  Cantidad: number,
  NumPagina: number,
  options?: { signal?: AbortSignal },
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTACASOSACTIVOS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Cantidad: Cantidad,
    NumPagina: NumPagina,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
    //signal: options?.signal,
  };

  return await axios(config);
};
export const BackendListaCasosActivosPorContrato = async (
  IdCliente: number,
  id_contrato: number,
  tipoTicket: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASCASOACTIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  let data = JSON.stringify({
    serviceRequestInput: {
      id_contrato: id_contrato,
      tipoTicket: tipoTicket, //"Activos" // "Archivados"
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaCasosArchivadosPorContrato = async (
  IdCliente: number,
  id_contrato: number,
  tipoTicket: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASCASOACTIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  let data = JSON.stringify({
    serviceRequestInput: {
      id_contrato: id_contrato,
      tipoTicket: tipoTicket, //"Activos" // "Archivados"
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaCasosArchivado = async (
  Cantidad: number,
  NumPagina: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTACASOSARCHIVADOS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Cantidad: Cantidad,
    NumPagina: NumPagina,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasAbiertasPorIdUsuario = async (
  UsuarioBonita: number,
  Cantidad: number, //2, // 0 para traer todos
  NumPagina: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_LISTATAREASABIERTASPORIDUSUARIO,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    UsuarioBonita: UsuarioBonita,
    Cantidad: Cantidad, // 0 para traer todos
    NumPagina: NumPagina, // 0 para traer todos, comienza a contar a par
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendListaTareasAbiertasPorUsuarioCaso = async (
  Usuario: string,
  Caso: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_LISTATAREASABIERTASPORUSUARIOCASO,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Usuario: Usuario,
    Caso: Caso,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasAbiertasPorUsuario = async (
  Cantidad: number, //2, // 0 para traer todos
  NumPagina: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASABIERTASPORUSUARIO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ Cantidad: Cantidad, NumPagina: NumPagina });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasTomadasPorUsuario = async (caseId: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASTOMADASPORUSUARIO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasEnEjecucionCaso = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASENEJECUCIONCASO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasCompletadasPorUsuario = async () => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_LISTATAREASCOMPLETADASCASOPORUSUARIO,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasAbiertasTomadasUsuario = async (
  Cantidad: number, //2, // 0 para traer todos
  NumPagina: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_LISTATAREASABIERTASTOMADASUSUARIO,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Cantidad: Cantidad, // 0 para traer todos
    NumPagina: NumPagina, // 0 para traer todos, comienza a contar a par
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaNoTomadasCaso = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASNOTOMADASCASO);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasCompletadasPorCaso = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASCOMPLETADASPORCASO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendListaTareasNoTomadasCaso = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_LISTATAREASNOTOMADASCASO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendCategoriaPorId = async (IdCategoria: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CATEGORIAPORID);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdCategoria: IdCategoria,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendTareaPorId = async (caseId: string, taskId: string) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREAACTIVAPORID);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    id: taskId,
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendBusquedaCasosTareas = async (payload: IPayloadBuscaquedaCasosTareas) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_BUSQUEDA_CASOS_TAREAS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify(payload);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendUltimaTareaCasoActivo = async (
  IdCliente: number,
  caseId: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_ULTIMATAREACASOACTIVO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    caseId: caseId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendClienteResultados = async (
  IdContrato: number,
  Fecha: string,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_RESULTADOS);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    contrato: {
      IdContrato: IdContrato,
    },
    Fecha: Fecha,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendClienteResultado = async (IdCliente: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_RESULTADO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdCliente: IdCliente,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerProcesoPorCliente = async (
  IdCliente: number,
  TipoTicketIdTipo: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_PROCESOPOR_CLIENTE);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    cliente: {
      IdCliente: IdCliente,
    },
    tipoTicket: {
      IdTipo: TipoTicketIdTipo,
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerTipoTicketPorCliente = async (IdCliente: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_TIPO_TICKET);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({});

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendTicketModificar = async (
  ticketModificarPost: ITicketModificarPost,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TiCKET_MODIFICAR);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    issue: {
      issue_id: ticketModificarPost.issue.issue_id,
      notes: ticketModificarPost.issue.notes,
      status_id: ticketModificarPost.issue.status_id,
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendTareaResolver = async (
  iTareaResolverPost: ITareaResolverPost,
  IdContratoTarea: number,
  contratoTarea: any,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_RESOLVER);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = SwitchIdContratoTarea(
    iTareaResolverPost,
    IdContratoTarea,
    contratoTarea,
  );

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendTareaResolverOperador = async (
  iTareaResolverPost: ITareaResolverPost,
  IdContratoTarea: number,
  contratoTarea: any,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_RESOLVER_OPERADOR);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = SwitchIdContratoTarea(
    iTareaResolverPost,
    IdContratoTarea,
    contratoTarea,
  );

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendTicketInsertar = async (iCrearCaso: ICrearCaso) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TICKET_INSERTAR);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Prioridad: iCrearCaso.Prioridad,
    ticketBonita: { ...iCrearCaso.iTicketInsertarPost.ticketBonita },
    ticketGlpi: {
      input: {
        name: iCrearCaso.iTicketInsertarPost.ticketGlpi.input.name,
        content: iCrearCaso.iTicketInsertarPost.ticketGlpi.input.content,
        urgency: iCrearCaso.iTicketInsertarPost.ticketGlpi.input.urgency,
        priority: iCrearCaso.iTicketInsertarPost.ticketGlpi.input.priority,
      },
    },
    CustomFields: iCrearCaso.iTicketInsertarPost.CustomFields,
    TicketRedmine: iCrearCaso.TicketRedmine,
    ActivaGuardia: iCrearCaso.ActivaGuardia,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendTareaTomarLiberar = async (
  iTareaTomarLiberarPost: ITareaTomarLiberarPost,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_TOMAR_LIBERAR);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    id: String(iTareaTomarLiberarPost.id),
    assigned_id: iTareaTomarLiberarPost.assigned_id, // 1 para tomarla (OUT), 0 para liberarla (IN)
    displayName: iTareaTomarLiberarPost.displayName,
    state: iTareaTomarLiberarPost.state, // Id del Modo, entero entre comillas, para ejecutar el check in out
    executedBy: iTareaTomarLiberarPost.executedBy, // Usuario Solicitante, para ejecutar el che
    type: iTareaTomarLiberarPost.type,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendTareaTomarLiberarOperador = async (
  iTareaTomarLiberarPost: ITareaTomarLiberarPost,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_TOMAR_LIBERAR_OPERADOR);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    id: String(iTareaTomarLiberarPost.id),
    assigned_id: iTareaTomarLiberarPost.assigned_id, // 1 para tomarla (OUT), 0 para liberarla (IN)
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendConsumosPorCaso = async (IdCaso: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CONSUMO_CASO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({ Caso: IdCaso });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendContratoPorCliente = async (IdCliente: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CONTRATO);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    cliente: {
      IdCliente: IdCliente,
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendClientePorContrato = async (IdContrato: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_CLIENTE_CONTRATO);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdContrato: IdContrato,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendPonderacion = async (
  IdContrato: number,
  IdModo: number,
  IdFranja: number,
  Dia: number,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_PONDERACION);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    contrato: {
      IdContrato: IdContrato,
    },
    modo: {
      IdModo: IdModo,
    },
    franja: {
      IdFranja: IdFranja,
    },
    Dia: Dia,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendSaldoClearing = async (IdContrato: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_SALDO_CLEARING);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    contrato: {
      IdContrato: IdContrato,
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendItemConfiguracion = async (IdCliente: number) => {
  const { IdSesion, tokenBacked } = await credenciales();

  let url = getApiUrl("" + process.env.REACT_APP_ITEMS_CONFIGURACION);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  let data = JSON.stringify({
    contrato: {
      cliente: {
        IdCliente: IdCliente,
      },
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendTareaPorCatalogo = async (IdCategoria: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_TAREA_CATEGORIA);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  let data = JSON.stringify({
    categoria: {
      IdCategoria: IdCategoria,
    },
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
export const BackendCatalogoTareaPorId = async (IdTareaCatalogo: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_CATALOGO_POR_ID_TAREA_CATALOGO,
  );

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    IdTareaCatalogo: IdTareaCatalogo,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerTareasTicket = async (Caso: number) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_OBTENER_TAREAS_CASO);

  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    Caso: Caso,
  });
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendActualizarConfiguracionNotificacion = async (
  datos: IActualizarConfiguracionRequest,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_ACTUALIZAR_CONFIGURACION_NOTIFICACION,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify(datos);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};

export const BackendObtenerConfiguracionesNotificacion = async (
  datos: IObtenerConfiguracionesRequest,
) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl(
    "" + process.env.REACT_APP_OBTENER_CONFIGURACIONES_NOTIFICACIONES,
  );
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify(datos);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
